import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Grid, Box, useTheme } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { HOTELS, FLIGHTS, ASSIST } from '@shared/helpers/routes';
import { SHOW_FLI } from '@shared/conf/env';
import { useSelector } from 'react-redux';
import useWindowSize from '@shared/hooks/useWindowsSize';
import DollarHeader from '@shared/layout/Header/DollarHeader';
import { sxStyled } from './styles';

const TabsHeader = ({ site = 0 }) => {
  const [value, setValue] = useState(site);
  const history = useHistory();
  const screenSize = useWindowSize();
  const pageConfiguration = useSelector(store => store.pageConfiguration);
  const showFli = Number.parseInt(SHOW_FLI);
  const theme = useTheme();

  useEffect(() => {
    if (site !== value) setValue(site);
  }, [site]);

  const styles = sxStyled({
    theme,
    value,
    pageConfiguration,
    screenWidth: screenSize.width,
    showDollarInfo: pageConfiguration.site_functions.showDollarInfo,
    showFli,
  });

  const scrollToSection = () => {
    const pathnames = [
      '/flights',
      '/hotels',
      '/assist-card',
      '/dollar-exchange',
    ];
    if (pathnames.includes(history.location.pathname)) {
      document
        .getElementById('scrollTo')
        ?.scrollIntoView({ behavior: 'smooth' });
    } else {
      history.push({ pathname: '/flights' });
    }
  };

  const handleChange = (_event, newValue) => {
    setValue(newValue);
    const actions = {
      0: () => history.push(FLIGHTS),
      1: () => history.push(HOTELS),
      2: () =>
        pageConfiguration.site_functions.pagePackage
          ? history.push('/packages')
          : scrollToSection(),
      3: () => history.push(ASSIST),
      5: () => scrollToSection(),
    };
    if (actions[newValue]) actions[newValue]();
  };

  return (
    <Grid container sx={styles.gridContainer}>
      <Box sx={styles.tabsBox}>
        <Tabs
          value={+value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={false}
          sx={styles.tabs}
        >
          {styles.tabsConfig
            .filter(tab => tab.show !== false)
            .map(tab => (
              <Tab
                key={tab.id}
                icon={styles.renderTabIcon(tab)}
                label={tab.name}
                sx={styles.tabSx(tab.name, tab.id)}
              />
            ))}
        </Tabs>
      </Box>

      <Box sx={styles.dollarBox}>
        <DollarHeader />
      </Box>
    </Grid>
  );
};

export default TabsHeader;
